<template>
    <div class="hierarchy">
        <Popup :opened="opened === 'tag'" @close="opened = null">
            <template v-if="selected != null">
                <div class="parents">
                    <div @click="selectTag(p)" v-for="p in parents" :key="p._id">{{ p.name }}</div>
                </div>

                <h3>{{ selected.name }} ({{ selected._id }})</h3>
                <div class="split">
                    <div class="custom-input">
                        <input placeholder="Name" v-model="selected.name">
                    </div>
                    <div class="custom-input">
                        <input placeholder="Equivalent" v-model="equivalent">
                        <button @click="selected.equivalents.push(equivalent.toString()); equivalent = '';">+</button>
                    </div>
                </div>
                <div class="split">
                    <div/>
                    <div class="equivalents">
                        <p
                            v-for="(e, index) in selected.equivalents"
                            :key="e"
                            @click="selected.equivalents.splice(index, 1)">
                            {{ e }}
                        </p>
                    </div>
                </div>
                <div class="split">
                    <input class="styledInput" placeholder="Parent" v-model="selected.parent">
                    <div>
                        <button class="green-btn" @click="newTag.parent = selected._id; opened = 'new'">Add a child</button>
                    </div>
                </div>
                <div>
                    <button class="green-btn submit-btn" @click="chanegTag()">Save</button>
                </div>
                <div class="children">
                    <p @click="selectTag(tag)" v-for="tag in tags[type].filter(t => t.parent === selected._id)" :key="tag._id">{{ tag.name }}</p>
                </div>
                <div class="products">
                    <router-link
                        target="_blank"
                        :to="{ name: 'admin_products_variant', params: { id: v._id }}"
                        v-for="v in products"
                        :key="v._id"
                        class="item">
                        <img class="adm-img" v-lazy="imgURL+'/'+v.mainPicture" alt="main picture">
                    </router-link>
                </div>
                <div>
                    <button @click="deleteTag(selected._id)" class="remove">Delete tag</button>
                </div>
                <div class="styledForm">
                    <div class="form">
                        <h3>Fusion two tags (this one will be removed)</h3>
                        <div class="custom-input">
                            <input type="text" placeholder="Tag id" v-model="fusionid">
                            <button @click="fusion()" class="green-btn">Fusion</button>
                        </div>
                    </div>
                </div>
            </template>
        </Popup>
        <Popup :opened="opened === 'new'" @close="opened = null" title="New Tag">
            <div class="form styledForm newTag">
                <input class="styledInput" placeholder="Name" v-model="newTag.name">
                <div class="split">
                    <select class="styledInput" v-model="newTag.type">
                        <option value="style">Style</option>
                        <option value="category">Category</option>
                        <option value="tag">Tags</option>
                        <option value="devices">Device</option>
                        <option value="materials">Technic</option>
                    </select>
                    <input class="styledInput" placeholder="Parent" v-model="newTag.parent">
                </div>
                <div class="custom-input">
                    <input class="styledInput" placeholder="Equivalent" v-model="equivalent">
                    <button @click="newTag.equivalents.push(equivalent.toString()); equivalent = '';" class="green-btn">+</button>
                </div>
                <div class="equivalents">
                    <p
                        v-for="(e, index) in newTag.equivalents"
                        :key="e"
                        @click="newTag.equivalents.splice(index, 1)">
                        {{ e }}
                    </p>
                </div>
                <button class="green-btn" @click="addTag()">Create tag</button>
            </div>
        </Popup>
        <h2>Hierarchy</h2>
        <div class="centered">
            <button class="green-btn" @click="opened = 'new'">New tag</button></div>
        <div class="types">
            <div @click="changeType('style')" :class="{'selected': type === 'style'}">Style</div>
            <div @click="changeType('category')" :class="{'selected': type === 'category'}">Category</div>
            <div @click="changeType('tag')" :class="{'selected': type === 'tag'}">Tags</div>
            <div @click="changeType('devices')" :class="{'selected': type === 'devices'}">Device</div>
            <div @click="changeType('materials')" :class="{'selected': type === 'materials'}">Technic</div>
        </div>
        <div class="form-search">
            <autocomplete
                :source="tags[type]"
                resultsValue="_id"
                :resultsDisplay="(e) => `${e.name} ${e.equivalents.length < 1 ? '' : `(${e.equivalents.map((eq) => eq)})`}`"
                @selected="(item) => selectTag(tags[type].filter(e => e._id === item.value)[0])"
            />
        </div>
        <div class="tags">
            <div @click="selectTag(tag)" v-for="tag in tags[type].filter(t => t.parent === null || t.parent === '' || typeof t.parent === 'undefined')" :key="tag._id">{{ tag.name }}</div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import Autocomplete from 'vuejs-auto-complete'
    import Popup from "../../components/Popup";

    export default {
        name: "AdminHierarchy",
        components: {Popup, Autocomplete},
        computed: {
            ...mapGetters('product', [
                'tags',
            ]),
        },
        created() {
            this.getTags('style');
        },
        data() {return {
            type: 'style',
            opened: null,
            selected: null,
            newTag: {
                name: '',
                type: 'style',
                parent: null,
                equivalents: []
            },
            parents: [],
            products: [],
            equivalent: '',
            imgURL: "http://163.172.150.46:3000/img",
            fusionid: '',
        }},
        methods: {
            ...mapActions('product', [
                'getTags',
                'getTagParents',
                'getTagProducts',
                'removeTag',
                'createTag',
                'updateTag',
                'mergeTags',
            ]),
            changeType(type) {
                this.type = type;
                this.getTags(type);
            },
            async selectTag(tag) {
                this.parents = [];
                this.opened = 'tag';
                this.equivalent = '';
                this.selected = tag;
                const data = await this.getTagParents(tag._id);
                this.parents = data.parents.reverse();
                this.products = await this.getTagProducts(tag._id);
            },
            deleteTag(id) {
                const self = this;
                if (!confirm('Are you sure to delete this tag ?')) return;
                this.removeTag({id});
                self.opened = null;
                self.selected = null;
            },
            addTag() {
                this.createTag(this.newTag);
                this.newTag = {
                    name: '',
                    type: this.type,
                    parent: null,
                    equivalents: []
                };
                this.equivalent = '';
                this.opened = null;
            },
            chanegTag() {
                this.updateTag(this.selected).then(() => {
                    this.equivalent = '';
                });
            },
            fusion() {
                if (this.selected._id === this.fusionid) return;
                this.mergeTags({from: this.selected._id, to: this.fusionid, type: this.type}).then(() => {
                    this.selected = null;
                });
                this.opened = null;
                this.selected = null;
            },
        }
    }
</script>

<style scoped lang="scss">
    h2 {
        margin: 0 30px 30px;
    }
    .hierarchy {
        box-sizing: border-box;
    }
    .types {
        display: flex;
        border-radius: 5px;
        margin: auto;
        width: fit-content;
        overflow: hidden;
        margin-bottom: 20px;
        justify-content: center;
        align-items: center;

        div {
            padding: 8px 15px;
            background-color: var(--main-green);
            color: #fff;
            cursor: pointer;
            border: 1px solid var(--main-green);
            border-width: 1px 1px 1px 0;

            &:not(:last-child) {
                border-right: 1px solid #fff;
            }
            &:first-child {
                border-radius: 5px 0 0 5px;
                border-left-width: 1px;
            }
            &:last-child {
                border-radius: 0 5px 5px 0;
            }
            &.selected {
                background-color: #fff;
                color: var(--main-green);
            }
        }
    }
    .form {
        max-width: 80%;
        margin: auto;
    }
    .tags {
        max-width: 80%;
        margin: auto;
        display: grid;
        grid-template-columns: repeat(8, minmax(0, 1fr));
        grid-template-rows: 1fr;
        border: solid var(--main-green);
        border-width: 1px 0 0 1px;

        > div {
            padding: 5px;
            cursor: pointer;
            border: solid var(--main-green);
            border-width: 0 1px 1px 0;
            display: flex;
            justify-content: center;
        }
    }
    .parents {
        display: flex;
        border: 1px solid #000;
        overflow: scroll;

        div {
            padding: 5px 10px;
            cursor: pointer;

            &:not(:last-child) {
                border-right: 1px solid #000;
            }
        }
    }
    .split {
        display: flex;
        width: 100%;

        > * {
            flex: 1;
            width: 50%;
            display: flex;

            &:first-child {
                margin-right: 20px;
            }
            .green-btn {
                white-space: nowrap;
                width: fit-content;
                padding: 5px 10px;
                margin-right: 20px;
            }
        }
    }
    .custom-input {
        display: flex;
        input {
            flex: 1;
            padding: 10px;
            border: 1px solid #000;
            border-radius: 5px 0 0 5px;
        }
        button {
            background-color: var(--main-green);
            color: #fff;
            border: 0;
            width: 40px;
            font-size: 20px;
            border-radius: 0 5px 5px 0;
            cursor: pointer;
        }
    }
    .children {
        margin-top: 20px;
    }
    .children, .equivalents {
        display: flex;
        flex-wrap: wrap;
        max-height: 300px;
        overflow-y: scroll;
        > p {
            background-color: var(--main-green);
            color: #fff;
            font-size: 12px;
            margin: 0 5px 5px 0;
            padding: 3px 8px;
            cursor: pointer;
        }
    }
    .submit-btn {
        margin: auto;
        padding: 10px 25px;
        width: auto;
    }
    .remove {
        border: 0;
        padding: 10px 25px;
        background-color: #f44336;
        color: #fff;
        font-weight: bold;
        border-radius: 3px;
        cursor: pointer;
        margin: auto;
        display: block;
        margin-top: 30px;
    }
    .newTag {
        > .green-btn {
            width: auto;
            border-radius: 2px;
            margin: auto;
            display: block;
            padding: 10px 25px;
        }
    }
    .centered {
        display: flex;
        justify-content: center;
        margin-bottom: 20px;
        button {
            padding: 10px 25px;
            white-space: nowrap;
            border-radius: 3px;
            width: auto;
        }
    }
    .products {
        display: flex;
        flex-wrap: wrap;
        padding: 0;
        margin-bottom: 30px;
        max-height: 300px;
        overflow-y: scroll;

        > a {
            height: 120px;
            width: 80px;
            border-radius: 5px;
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;
            margin: 0 10px;

            img {
                height: 100%;
            }
        }
    }
    .form-search {
        width: 60%;
        min-width: 300px;
        margin: auto;
    }
    .styledForm {
        margin-top: 20px;
    }
</style>
